import React from "react";
import { CertificateContainer, CertificateLink, ScrollDiv } from "./style";
import { ReturnButton } from "../../../pages/Login/style";

interface CertificateDropdownProps {
    documents: string[]
}

interface LinksCertificatesProps {
    link: string,
    index: number
}

const LinksCertificates: React.FC<LinksCertificatesProps> = ({ link, index }) => {
    return (
        <CertificateLink key={index} href={link} target="_blank" rel="noreferrer">Certificado {index + 1}</CertificateLink>
    )
}

const CertificateDropdown: React.FC<CertificateDropdownProps> = ({ documents }) => {

    if (documents.length <= 3) {
        return (

            <CertificateContainer>
                {documents.map((document: string, index: number) => {
                    return <LinksCertificates key={index} link={document} index={index} />
                })}

            </CertificateContainer>
        )
    } else {
        return (

            <CertificateContainer>
                <ScrollDiv>
                    {documents.map((document: string, index: number) => {
                        return <LinksCertificates key={index} link={document} index={index} />
                    })}
                </ScrollDiv>

            </CertificateContainer>
        )
    }
}

export default CertificateDropdown